import React, { useRef } from "react"
import "./copyToClipboard.scss";

interface CopyToClipboardProps {
  /**
   * The text to copy to the clipboard.
   */
  readonly copyText: string;
  /**
   * Optional extra callback to run when the text is copied to the clipboard.
   *
   * If it returns a value, that value will be awaited before the popup is shown.
   */
  readonly onClick?: (() => void) | (() => Promise<void>);
}

function CopyToClipboard(props: CopyToClipboardProps) {
  const popup = useRef<HTMLDivElement>(null);
  const timeout = useRef<NodeJS.Timeout | null>(null);

  async function onButtonClick(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) {
    const promise = navigator.clipboard.writeText(props.copyText);
    await props.onClick?.();
    await promise;

    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    const { current } = popup;

    if (current) {
      current.classList.add("visible");
      current.style.left = event.clientX + "px";
      current.style.top = (event.clientY - current.offsetHeight) + "px";

      timeout.current = setTimeout(() => {
        current.classList.remove("visible");
      }, 3000);
    }
  }

  function onPopupClick() {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    popup.current?.classList.remove("visible");
  }

  return <>
    <span onClick={onButtonClick} title="Copy to Clipboard" className="copyIcon">
      <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.8333 1.125H1V11.7778" stroke="#5F9EC5" strokeWidth="1.22917" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.27771 4.40277H14.111V14.2361C14.111 14.6708 13.9384 15.0876 13.631 15.395C13.3237 15.7023 12.9068 15.875 12.4722 15.875H5.9166C5.48194 15.875 5.06508 15.7023 4.75773 15.395C4.45038 15.0876 4.27771 14.6708 4.27771 14.2361V4.40277Z" stroke="#5F9EC5" strokeWidth="1.22917" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </span>
    <div className="copyPopup" ref={popup} onClick={onPopupClick}>
      "{props.copyText}" copied to clipboard
    </div>
  </>
}

export default CopyToClipboard
